import api from "@/api/client";

/** Turn `/api/uploads/...` into a full URL the editor and img tags can load. */
export function resolveMediaUrl(fileUrl) {
  if (!fileUrl) return "";
  if (/^https?:\/\//i.test(fileUrl)) return fileUrl;
  const base = (
    process.env.REACT_APP_BACKEND_URL ||
    (typeof window !== "undefined" ? window.location.origin : "")
  ).replace(/\/$/, "");
  const path = fileUrl.startsWith("/") ? fileUrl : `/${fileUrl}`;
  return `${base}${path}`;
}

/** Editor.js / clipboard blobs often have no filename extension — backend requires one. */
export function normalizeUploadFile(file) {
  if (!file) return file;
  const name = file.name || "";
  if (/\.\w{2,5}$/i.test(name)) return file;
  const type = file.type || "image/png";
  let ext = (type.split("/")[1] || "png").toLowerCase();
  if (ext === "svg+xml") ext = "svg";
  if (ext === "jpeg") ext = "jpg";
  return new File([file], `upload.${ext}`, { type });
}

export async function uploadSpaceMedia(spaceId, file) {
  const fd = new FormData();
  fd.append("file", normalizeUploadFile(file));
  const { data } = await api.post(`/spaces/${spaceId}/media/upload`, fd);
  return resolveMediaUrl(data.file_url);
}
